import React from 'react'

//page hooks
import UseUsersScreen from './WorkspaceUsersScreen.hooks';

//components
import SimplePageSelector from  '@/components/elements/global/PageSelectors/SimplePageSelector';
import SimpleTable from  '@/components/elements/global/tables/SimpleTable/SimpleTable';
import LinkStyleButton from  '@/components/elements/global/buttons/LinkStyleButton';
import CheckboxPanel from  '@/components/elements/global/dropdown/CheckboxPanel';
import SimpleSearchInput from  '@/components/elements/search/simpleSearchInput';
import NotificationBar from  '@/components/elements/languages/NotificationBar';

//styling
import "../../../../../css/orgSettings/users/users.scss"



const WorkspaceUsersScreen = () => {  
    const {filterButtonText, filterButtonLabel, searchInputLabel, userDataPaginationSettings, panelTitle, archivedUsersLabel, noDataMessage, notificationDetails, setSearchUsersString, searchUsersString, setPage, isLoading, tableContent, showSimpleTable, onIncludeArchivedUserClick, includeArchivedUsers, showFilterPanel, onShowFilterPanelClick} = UseUsersScreen();

    return(
        <div className="users-tab-container" data-testid="workspace-users-tab">
            <div className='user-top-button-panel'> 
                <LinkStyleButton content={filterButtonText} ariaLabel={filterButtonLabel} onButtonClick={onShowFilterPanelClick}  />
                <SimpleSearchInput ariaLabel={searchInputLabel} setSearchString={setSearchUsersString} searchString={searchUsersString} />
            </div>

            {showFilterPanel && <CheckboxPanel panelTitle={panelTitle} items={[{id: 1, content:archivedUsersLabel, isSelected: includeArchivedUsers, onCheck: onIncludeArchivedUserClick}]} /> }

            {showSimpleTable && <SimpleTable isLoading={isLoading} simpleTableContent={tableContent} noDataMessage={noDataMessage} maxContentLength={20} isInfiniteScroll={false} />}
        
            {userDataPaginationSettings?.hasPagination && <SimplePageSelector currentPage={userDataPaginationSettings.currentPage} totalPages={userDataPaginationSettings.totalPages} setPage={setPage} />}
        
            <NotificationBar show={notificationDetails.show} notificationStatus={notificationDetails.status} msg={notificationDetails.message} />
        </div>
    )
}

export default WorkspaceUsersScreen